export default __webpack_public_path__ + "c50f587bd7f2fc18af519bc1230f981d.png";